<template>
<!-- 选对小工具-个人中心 -->
  <div class="xd-person">
      <!-- conent -->
      <div class="content">
          <div v-for="(item,index) in list" :key="index" class="list">
            <div class="top">
                <img :src="item.headimgurl" alt="">
                <div class="text">{{item.name}}</div>
            </div>
            <div class="bottom">
                <div @click="toInformation(item.id)" class="child">
                    <img src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/my-info.png" alt="">
                    <div class="text">基本资料</div>
                </div>
                <div @click="toCollection(item)" class="child">
                    <img src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/my-mess.png" alt="">
                    <div class="text">信息收集</div>
                </div>
                <div @click="toReport(item)" class="child">
                    <img src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/my-report.png" alt="">
                    <div class="text">咨询报告</div>
                </div>
            </div>
            <div v-if="item.counselling_status==0" class="label">
                待分配
            </div>
            <div v-if="item.counselling_status==1" class="label">
                咨询中
            </div>
            <div v-if="item.counselling_status==2" class="label">
                已结束
            </div>
          </div>
      </div>
      <!-- footer toolbar -->
      <div class="footer-toolbar">
          <div class="child">
              <img src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/message-on.png" alt="">
              <p>我的咨询</p>
          </div>
          <div class="child"  @click="$router.push('/xd_info')">
              <img src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/user-icon.png" alt="">
              <p>个人资料</p>
          </div>
      </div>
  </div>
</template>

<script>
import { shareCon } from "@/utils/wxconfig";
import { deepCopy,setSessionStorage,getSessionStorage } from "@/utils/tools";
import { orderList,userInfo } from "@/api/xuandui_gadgets"
export default {
    data(){
        return{
            loading: false,
            finished: false,
            error: false,
            list:[],
            pages:{
                page: 0,
                size: 10,
            },
            user_id:null,
            info:{},
            // 是否是咨询师
            consultantBool:false
        }
    },
    methods:{
        // 跳转报告
        toReport(item){
            let q = this.$route.query;
            // 是否是咨询师   true 咨询师，false 用户
            if(this.consultantBool){
                 if(!item.report){
                    // 如果已有，跳转，否则进行第一个填写
                    this.$router.push({
                        path:item.report?'/xd_report_list':'/xd_report_form',
                        query:{
                            oid:item.id
                        }
                    });
                }else{
                    // 如果已有，跳转
                    this.$router.push({
                        path:'/xd_consult_report',
                        query:{
                            oid:item.id
                        }
                    });
                }
            }else{
                if(!item.report){
                    this.$toast('报告还未生成！');
                }else{
                    // 如果已有，跳转
                    this.$router.push({
                        path:'/xd_consult_report',
                        query:{
                            oid:item.id
                        }
                    });
                    
                }
            }
            
        },
        // 跳转信息收集
        toCollection(item){
            // 判断是否都完成信息填写
            // 如果已有，跳转列表页，否则进行第一个填写
            this.$router.push({
                path:item.collection?'/xd_experience_list':'/xd_add_experience',
                query:{
                    oid:item.id
                }
            });
            
        },
        // 跳转基本信息
        toInformation(id){
            this.$router.push({
                path:'/xd_infomation',
                query:{
                    oid:id
                }
            });
        },
        // 转base64
        b64Encode(str) {
            return window.btoa(encodeURIComponent(str));
        },
        b64Decode(str) {
            return decodeURIComponent(window.atob(str));
        },
        // 初始化获取数据
        pullData(){
            let q = this.$route.query;
            // 判断是否是咨询师
            if(q.consultant && this.b64Decode(q.consultant)=='zx'){
               setSessionStorage(this.$route.path,'consultant',q.consultant);
            }
            this.consultantBool = getSessionStorage(this.$route.path,'consultant') && this.b64Decode(getSessionStorage(this.$route.path,'consultant')) == 'zx';
            if(this.user_id){
                this.getListData();
            }else{
                this.getUserInfo();
            }
            document.title = '咨询订单';
        },
        // 获取用户信息
        getUserInfo(){
            // 获取用户信息
            userInfo().then((data)=>{
                this.info = data;
                this.user_id = data.user_id;
                this.getListData();
            });
        },
        // 获取列表信息
        getListData(){
             //调用加载中
            this.$emit('loadingHandle',true,"拼命加载中...");
            this.pages.page += 1;
            let q = this.$route.query;
            let obj = {
                page:this.pages.page,  //页码，默认1
                size:this.pages.size,   //每页数量，默认10
                category_id:2,//做自己节传1,选对小工具传2
                status:1,
                user_id:this.user_id
            };
            orderList(obj).then((data)=>{
                    //关闭加载中
                this.$emit('loadingHandle',false);
                if(data.error>0){
                    this.$toast(data.msg);
                    return
                }
                this.pages = data.pager;
                
                this.list = Array.from(new Set([...this.list,...data.list]));
                
                // 加载状态结束
                this.loading = false;

                // 数据全部加载完成
                if(data.pager.page_count == data.pager.page) {
                    this.finished = true;
                }
            }).catch(err=>{
                this.error = true;
            });
        }
    },
    created(){
        this.pullData();
        shareCon('index',this);
    }
}
</script>
<style lang="scss">
    body{
        background-color: #F7F8F9;
    }
</style>
<style lang="scss" scoped>
.xd-person{
    display: flex;
    flex-direction: column;
    .content{
        width:100%;
        border-radius: 60px 0px 0px 0px;
        flex: 1;
        padding: 20px 30px 118px;
        .list{
            position: relative;
            display: flex;
            flex-direction: column;
            padding: 30px;
            background-color: #FFFFFF;
            border-radius: 20px;
            margin-bottom: 20px;
            overflow: hidden;
            &:last-of-type{
                margin-bottom: 0;
            }
            .top{
                display: flex;
                align-items: center;
                margin-bottom: 60px;
                img{
                    width: 96px;
                    height: 96px;
                    border-radius: 50%;
                    margin-right: 16px;
                }
                .text{
                    font-size: 32px;
                    color: #2B333A;
                    line-height: 44px;
                    font-weight: 600;
                }
            }
            .bottom{
                display: flex;
                align-items: center;
                padding: 0 30px;
                justify-content: space-between;
                .child{
                    text-align: center;
                    img{
                        width: 72px;
                    }
                    .text{
                        color: #2B333A;
                        font-size: 24px;
                        font-weight: 400;
                    }
                }
            }
            .label{
                text-align: center;
                position: absolute;
                top: 0;
                right: 0;
                width: 120px;
                height: 62px;
                background: rgba($color: #FF9000, $alpha: 0.2);
                border-radius: 0px 10px 0px 20px;
                font-size: 24px;
                font-weight: 400;
                color: #FF9000;
                line-height: 62px;
            }

        }
    }
    .footer-toolbar{
        position: fixed;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0;
        width: 100%;
        max-width: 750px;
        background-color: #FFFFFF;
        height: 98px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 144px;
        text-align: center;
        box-shadow: 0px -4px 16px 0px rgba(0, 0, 0, 0.04);
        .child{
            img{
                width: 48px;
                height: 48px;
            }
            p{
                font-size: 22px;
                font-weight: 400;
                color: #7D8289;
                line-height: 32px;
                text-shadow: 0px -8px 32px rgba(0, 0, 0, 0.04);
            }
        }
    }
}
</style>